import { migrateToNewSearch } from '../migrateToNewSearch';
import { EditorAppContext } from '../types';
import { Spec } from '@wix/site-search-common';

export const configurePagesTab = (
  appContext: EditorAppContext,
  pagesTabBuilder: any,
) => {
  const upgradeToNewSearch = appContext.experiments.enabled(
    Spec.UpgradeToNewSearch,
  );
  const deleteAction = {
    title: appContext.translate(
      'Site_Search_Editor_PageTitle_DeleteWixSiteSearch',
    ),
    icon: 'deleteAction',
    onClick: async (event: any) => {
      await appContext.editorSDK.application.uninstall('token', {
        openConfirmation: true,
      });
    },
  };

  const updateAppAction = {
    title: appContext.translate('Site_Search_Editor_PageTitle_UpdateApp'),
    icon: 'settings',
    onClick: async (event: any) => {
      await migrateToNewSearch(appContext);
    },
  };

  const tabActions =
    !appContext.isProductSlotInstalled && upgradeToNewSearch
      ? [deleteAction, updateAppAction]
      : [deleteAction];

  return pagesTabBuilder
    .set({
      displayName: appContext.translate('siteSearch.pages.app.displayName'),
    })
    .addAction(...tabActions);
};
